import { useEffect, useState } from "react";

import {
  Button,
  Menu,
  MenuItem,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material/styles";

import i18n from "i18next";
import English from "../../assets/img/countries/english.png";
import Vietnam from "../../assets/img/countries/vietnam.png";

const theme = createTheme({
  palette: {
    button: {
      color: "#3A505F",
    },
  },
});
const StyleButton = styled(Button)(() => ({
  color: "#3A505F",
  fontSize: "14px",
  fontWeight: "400",
  backgroundColor: "transparent",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));
const MenuStyle = styled(Menu)(() => ({
  "& .MuiList-root": {
    backgroundColor: "#F1F6FA",
    paddingTop: "0",
    color: "#3A505F",
    paddingBottom: "0",
  },
  "& .MuiPaper-root": {
    backgroundColor: "#F1F6FA",
  },
}));
export const LanguageMenu = () => {
  const [language, setLanguage] = useState("Vietnamese");

  /* ================= COOKIE CONSENT ================= */
  const getCookieConsent = () => {
    const match = document.cookie.match(
      /cookie_preferences_facialsense=([^;]+)/
    );
    if (!match) return null;

    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch {
      return null;
    }
  };

  const isFunctionalAllowed = () => {
    const consent = getCookieConsent();
    return consent?.functional === true;
  };

  /* ================= LANGUAGE HANDLER ================= */
  const handleLanguage = (lang, popupState) => {
    popupState?.close();

    setLanguage(lang);

    if (lang === "English") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("vi");
    }

    // ✅ chỉ lưu khi functional được phép
    if (isFunctionalAllowed()) {
      localStorage.setItem("lang", lang);
    }
  };

  /* ================= INIT LANGUAGE ================= */
  useEffect(() => {
    if (!isFunctionalAllowed()) {
      // ❌ không được dùng localStorage
      localStorage.removeItem("lang");
      setLanguage("Vietnamese");
      i18n.changeLanguage("vi");
      return;
    }

    const savedLang = localStorage.getItem("lang");
    if (savedLang) {
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang === "English" ? "en" : "vi");
    } else {
      setLanguage("Vietnamese");
      i18n.changeLanguage("vi");
    }
  }, []);

  /* ================= LISTEN CONSENT CHANGE ================= */
  useEffect(() => {
    const handleConsentChange = () => {
      if (!isFunctionalAllowed()) {
        localStorage.removeItem("lang");
        setLanguage("Vietnamese");
        i18n.changeLanguage("vi");
      }
    };

    window.addEventListener("cookie-consent-changed", handleConsentChange);
    return () =>
      window.removeEventListener("cookie-consent-changed", handleConsentChange);
  }, []);

  /* ================= UI ================= */
  return (
    <ThemeProvider theme={theme}>
      <PopupState variant="popover" popupId="language-menu">
        {(popupState) => (
          <>
            <StyleButton {...bindTrigger(popupState)}>
              <img
                src={language === "English" ? English : Vietnam}
                alt=""
                style={{ width: 24, marginRight: 5 }}
              />
              <p>{language === "English" ? "English" : "Tiếng Việt"}</p>
              <KeyboardArrowDownIcon />
            </StyleButton>

            <MenuStyle {...bindMenu(popupState)}>
              <MenuItem
                onClick={() => handleLanguage("English", popupState)}
              >
                <img src={English} style={{ width: 30, marginRight: 10 }} />
                English
              </MenuItem>

              <MenuItem
                onClick={() => handleLanguage("Vietnamese", popupState)}
              >
                <img src={Vietnam} style={{ width: 30, marginRight: 10 }} />
                Tiếng Việt
              </MenuItem>
            </MenuStyle>
          </>
        )}
      </PopupState>
    </ThemeProvider>
  );
};

